import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TreeNode } from 'primeng/api';

@Injectable()
export class NodeService {

    AppUrl = '';
    constructor(private readonly _http: HttpClient) {
        this.setAPIUrl();
    }

    setAPIUrl() {
        if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
            this.AppUrl = sessionStorage.getItem('BaseURL') || '';
        }
    }

    getFiles() {
        return this._http.get<any>('assets/files.json')
            .toPromise()
            .then(res => res.data as TreeNode[]);
    }
}
